import React, {useEffect, useState, setState} from 'react';
import LogEntry from "./LogEntry";

const LogList = ({data, setDone}) => {
    return (
        <div
            style={{

            }}
        >
            {data && data.map(it =>
                !it.done ? <LogEntry key={it.uid} data={it} setDone={setDone}/> : null
            )}
        </div>
    )
}

export default LogList
